import React from 'react';
import { useTranslation } from 'react-i18next';

const EmptyState = ({ subtitle }) => {
    const { t } = useTranslation('CashWallet');

    return (
        <div className="cash-wallet-empty-state">
            <div className="cash-wallet-empty-title">{t('Empty.Title')}</div>
            <div className="cash-wallet-empty-subtitle">{subtitle}</div>
        </div>
    );
};

export default EmptyState;
